/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function () {

	// Below are example event listeners.  They listen for theme events that Pipeline
	// fires in order to make it easier for you to add customizations.

	// Keep your scripts inside this IIFE function call to avoid leaking your
	// variables into the global scope.


	// document.addEventListener('theme:variant:change', function(event) {
	//   // You might use something like this to write a pre-order feature or a
	//   // custom swatch feature.
	//   var variant = event.detail.variant;
	//   var container = event.target;
	//   if (variant) {
	//     console.log('Container ———————— ↓');
	//     console.log(container);
	//     console.log('Variant —————————— ↓');
	//     console.log(variant);
	//     // ... update some element on the page
	//   }
	// });

	// document.addEventListener('theme:cart:change', function(event) {
	//   var cart = event.detail.cart;
	//   if (cart) {
	//     console.log('Cart ———————————— ↓');
	//     console.log(cart);
	//     // ... update an app or a custom shipping caluclator
	//   }
	// });
	// Fired when page loads to update header values
	// document.addEventListener('theme:cart:init', (e) => {
	//   console.log('theme:cart:init');
	//   console.log(e);
	// });

	// Debounced scroll listeners.  Up and down only fire on direction changes
	// These events are useful for creating sticky elements and popups.
	// document.addEventListener('theme:scroll', e => { console.log(e); });
	// document.addEventListener('theme:scroll:up', e => { console.log(e); });
	// document.addEventListener('theme:scroll:down', e => { console.log(e); });

	// Debounced resize listener to bundle changes that trigger document reflow
	// document.addEventListener('theme:resize', e => { console.log(e); });

	// Locks and unlocks page scroll for modals and drawers
	// These are commented out because firing them will lock the page scroll
	// the lock event must set `detail` to the modal or drawer body so the 
	// scroll locking code knows what element should maintain scoll. 
	// document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
	// document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));

	$(window).scroll(function () {
		if (window.scrollY == 0) {
			$('.product-add-popdown').removeClass('hasScrolled');
		} else {
			$('.product-add-popdown').addClass('hasScrolled');
		}
	});

	$(document).on('click', '.tab-link', function () {
		var tabIndex = $(this).data('tab');
		console.log('tab: ', tabIndex);
		$(".tab-collection-link").hide();
		$(".tab-collection-link-" + tabIndex).fadeIn(1000);
	});

	const collection_card_sliders = document.querySelectorAll(".collection-card-slider");
	collection_card_sliders.forEach((section, i) => {
		//console.log(section)
		var section_id = $(section).data('section-id');
		init_collection_slider(section_id);
		//setTimeout(function(){ init_collection_slider(section_id) }, 500);
	});
	function init_collection_slider(section_id) {
		//console.log('section_id: ', section_id)

		$('.ccs-' + section_id).slick({
			speed: 400,
			dots: false,
			cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
			touchThreshold: 10,
			slidesToShow: 3.1,
			slidesToScroll: 1,
			infinite: false,
			arrows: true,
			prevArrow: $('.csg-prev-' + section_id),
			nextArrow: $('.csg-next-' + section_id),
			//variableWidth: true,
			//swipeToSlide: true,
			//swipe: false,
			responsive: [
				{
					breakpoint: 900,
					settings: {
						slidesToShow: 2.5,
					}
				},
				{
					breakpoint: 600,
					settings: {
						slidesToShow: 1.3
					}
				}
			]
		}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
			$(".csg-prev-" + section_id).removeClass('at-end')
			$(".csg-next-" + section_id).removeClass('at-end')
			if (currentSlide == 1 && nextSlide == 0) {
				$(".csg-prev-" + section_id).addClass('at-end')
			}
			//console.log("sts", slick.$slides.length)
			if (slick.$slides.length == (nextSlide + slick.options.slidesToShow)) {
				$(".csg-next-" + section_id).addClass('at-end')
			}

		});
	}

	$('.collection-card-link-slider').slick({
		speed: 700,
		dots: false,
		cssEase: 'cubic-bezier(0.165, 0.840, 0.440, 1.000)',
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		arrows: true,
		"prevArrow": $('.csl-prev'),
		"nextArrow": $('.csl-next'),
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3,
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
				}
			}
		]
	}).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$(".csl-prev").removeClass('at-end')
		$(".csl-next").removeClass('at-end')
		if (currentSlide == 1 && nextSlide == 0) {
			$(".csl-prev").addClass('at-end')
		}

		if (slick.$slides.length == (nextSlide + slick.options.slidesToShow)) {
			$(".csl-next").addClass('at-end')
		}

	});
	// Slick
	// if ($('.exmaple').length) {
	//   $('.exmaple').slick({
	//     infinite: true,
	//     slidesToShow: 1,
	//     slidesToScroll: 1,
	//     mobileFirst: true,
	//     autooplay: true,
	//     prevArrow: '<button type="button" class="slick-prev"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#020202" d="M1.116 10.884a1.25 1.25 0 0 1 0-1.768l7.955-7.955A1.25 1.25 0 1 1 10.84 2.93L3.768 10l7.07 7.071a1.25 1.25 0 1 1-1.767 1.768l-7.955-7.955Zm1.765.366H2v-2.5h.881v2.5Z"/> </svg></button>',
	//     nextArrow: '<button type="button" class="slick-next"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 20"> <path fill="#020202" d="M10.884 10.884a1.25 1.25 0 0 0 0-1.768L2.929 1.161A1.25 1.25 0 1 0 1.16 2.93L8.232 10l-7.07 7.071a1.25 1.25 0 1 0 1.767 1.768l7.955-7.955Zm-1.765.366H10v-2.5h-.881v2.5Z"/> </svg></button>',
	//     responsive: [
	//       {
	//         breakpoint: 900,
	//         settings: {
	//           slidesToShow: 3,
	//           arrows: false,
	//           variableWidth: true
	//         }
	//       }
	//     ]
	//   });
	// }

	// ^^ Keep your scripts inside this IIFE function call to avoid leaking your
	// variables into the global scope.




	/* Slick needs no get Reinitialized on window Resize after it was destroyed */
	$(window).on('load resize orientationchange', function () {
		// custom--section-icons
		$('.custom--section-icons .grid--slider-slick').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel only on mobile screens */
			// slick on mobile
			if ($(window).width() > 599) {
				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('unslick');
				}
			}
			else {
				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						arrows: false,
						slidesToShow: 1,
						dots: true
					});
				}
			}
		});


		// custom--section-columns
		$('.custom--section-columns .grid--slider-slick').each(function () {
			var $carousel = $(this);
			/* Initializes a slick carousel only on mobile screens */
			// slick on mobile
			if ($(window).width() > 599) {
				if ($carousel.hasClass('slick-initialized')) {
					$carousel.slick('unslick');
				}
			}
			else {
				if (!$carousel.hasClass('slick-initialized')) {
					$carousel.slick({
						arrows: false,
						slidesToShow: 1.1,
						dots: false,
						infinite: false
					});
				}
			}
		});
	});

	// Collection page Filters hide show bug fix 
	$('.collection__filters__toggle, .collection__filters__outer .drawer__button.drawer__close').click(function () {
		$('.collection__content, .collection__nav__buttons').toggleClass('filters-is-hidden');
		$('.collection__filters__wrapper').toggleClass('drawer--visible-hack')
	});
	// $('.collection__filters__toggle.filters--default-visible').click(function (e){
	// setTimeout(function (){
	// 	$(this).removeClass('filters--default-visible');
	// 	$('.collection__filters__wrapper').removeClass('drawer--visible');
	// }, 100)
	// });
	// $('.collection__filters__toggle:not(.filters--default-visible)').click(function (e){
	// 	setTimeout(function (){
	// 	$(this).addClass('drawer--visible');
	// 	$('.collection__filters__wrapper').addClass('drawer--visible');
	// }, 100)
	// });

	// product page | update variant sku in breadcrumb

	$('.show-variant-sku--true .radio__button input').click(function () {
		// console.log($(this).data('variant-sku'));
		$('.current-sku').text($(this).data('variant-sku'));
	});
	$('.show-variant-barcode--true .radio__button input').click(function () {
		// console.log($(this).data('variant-barcode'));
		$('.current-barcode').text($(this).data('variant-barcode'));
	});


	// Hides / shows BUY FROM OUR RETAILERS buttons corresponding to the variant that is clicked.
	$('.form__selectors input').click(function () {
		var _val = $(this).data('variant-sku');
		$('.cswidget-wrapper button').each(function () {
			if (_val === $(this).data('product-sku')) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
	});


	// Testimonial Sliders
	if ($('.custom--section-quotes .quotes-slider').length) {
		$('.custom--section-quotes .quotes-slider').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: false,
			dots: true
		});
	}

	$('.product-slider .product-item').slick({
		infinite: false,
		slidesToShow: 4.2,
		arrows: true,
		prevArrow: $(".product-slider .csg-prev"),
		nextArrow: $(".product-slider .csg-next"),
		dots: false,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 599,
				settings: {
					slidesToShow: 1.2
				}
			}
		]
	});

	// Clean up white space in text. Shopify filters can only do so much... :-(
	var options = $('.collection-slider-grid .description *, .product-description *, .custom--collection-hero .collection__heading__text *, .shopify-policy__body *, .blog-content *, .blog__article__content *');
	for (index = 0; index < options.length; ++index) {
		options[index].innerHTML = options[index].innerHTML.replace(/\&nbsp;/g, ' ');
	}

	// open enxternal links in new tab
	var links = document.links;
	for (let i = 0, linksLength = links.length; i < linksLength; i++) {
		if (links[i].hostname !== window.location.hostname && !links[i].classList.contains("non-external")) {
			links[i].target = '_blank';
			links[i].rel = 'noreferrer noopener';
		}
	}

	// update cart number on cart page
	document.addEventListener('theme:cart:change', function(event) {
	  var cart = event.detail.cart;
	  if (cart) {
			let cart_count = cart.item_count
			if (cart_count == 1) {
				$('.general-title-count span').text(cart.item_count.toString() + " item");
			} else {
				$('.general-title-count span').text(cart.item_count.toString() + " items");
			}
	  }
	});

	// focus on search dropdown when clicked
	$('.desktop-search').click(function (e){
		e.preventDefault();
		$('#search-popdown').addClass('is-visible');
		$('.search__predictive__main input[type="search"]').focus();
	});

	// search dropdown
	$('#searchLink').click(function (e) {
		e.preventDefault();
		setTimeout(function (){	
			$(".search__predictive__form__button").click();
		}, 100)
	});
})();

// <a href="javascript:void(0);" onclick="zE('messenger', 'open');">open</a>
// Trigger for opening zendesk widget
$('.zenOpen').click(function () {
	zE(function () {
		zE.activate();
	});
});


// Temp hack for custom header v2 nav. 
// $('#shopify-section-custom-header-v2 .drawer__button.drawer__close , .header__drawer .drawer__menu:not(.consolidate) .sliderule__wrapper .sliderule__wrapper .mobile__menu__dropdown>.sliderow *').click(function (){
// 	$('.drawer__inner *').removeClass('is-visible');
// });




'use strict';

/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.11
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

var Ajaxinate = function ajaxinateConstructor(config) {
  var settings = config || {};
  /*
    pagination: Selector of pagination container
    method: [options are 'scroll', 'click']
    container: Selector of repeating content
    offset: 0, offset the number of pixels before the bottom to start loading more on scroll
    loadingText: 'Loading', The text changed during loading
    callback: null, function to callback after a new page is loaded
  */
  var defaultSettings = {
    pagination: '#AjaxinatePagination',
    method: 'scroll',
    container: '#AjaxinateLoop',
    offset: 0,
    loadingText: 'Loading',
    callback: null
  };
  // Merge configs
  this.settings = Object.assign(defaultSettings, settings);

  // Bind 'this' to applicable prototype functions
  this.addScrollListeners = this.addScrollListeners.bind(this);
  this.addClickListener = this.addClickListener.bind(this);
  this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
  this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
  this.destroy = this.destroy.bind(this);

  // Set up our element selectors
  this.containerElement = document.querySelector(this.settings.container);
  this.paginationElement = document.querySelector(this.settings.pagination);

  this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
  // Find and initialise the correct function based on the method set in the config
  if (this.containerElement) {
    var initializers = {
      click: this.addClickListener,
      scroll: this.addScrollListeners
    };
    initializers[this.settings.method]();
  }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
  if (this.paginationElement) {
    document.addEventListener('scroll', this.checkIfPaginationInView);
    window.addEventListener('resize', this.checkIfPaginationInView);
    window.addEventListener('orientationchange', this.checkIfPaginationInView);
  }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
  if (this.paginationElement) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.clickActive = true;
    if (this.nextPageLinkElement !== null) {
      this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
    }
  }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
  event.preventDefault();
  if (this.clickActive) {
    this.nextPageLinkElement.innerHTML = this.settings.loadingText;
    this.nextPageUrl = this.nextPageLinkElement.href;
    this.clickActive = false;
    this.loadMore();
  }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
  var top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
  var bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;
  if (top <= window.innerHeight && bottom >= 0) {
    this.nextPageLinkElement = this.paginationElement.querySelector('a');
    this.removeScrollListener();
    if (this.nextPageLinkElement) {
      this.nextPageLinkElement.innerHTML = this.settings.loadingText;
      this.nextPageUrl = this.nextPageLinkElement.href;
      this.loadMore();
    }
  }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
  this.request = new XMLHttpRequest();
  this.request.onreadystatechange = function success() {
    if (this.request.readyState === 4 && this.request.status === 200) {
      var newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
      var newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
      this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
      this.paginationElement.innerHTML = newPagination.innerHTML;
      if (this.settings.callback && typeof this.settings.callback === 'function') {
        this.settings.callback(this.request.responseXML);
      }
      this.initialize();
    }
  }.bind(this);
  this.request.open('GET', this.nextPageUrl);
  this.request.responseType = 'document';
  this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
  this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
  document.removeEventListener('scroll', this.checkIfPaginationInView);
  window.removeEventListener('resize', this.checkIfPaginationInView);
  window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndReturnThis() {
  // This method is used to unbind event listeners from the DOM
  // This function is called manually to destroy "this" Ajaxinate instance
  var destroyers = {
    click: this.removeClickListener,
    scroll: this.removeScrollListener
  };
  destroyers[this.settings.method]();
  return this;
};
